import { useEffect } from "react";
import { useAppSelector } from "@builder/store/store";



const useSystemUI = () => {
  const systemUI = useAppSelector(state => state.systemUI);

  useEffect(() => {
    if (systemUI.isDarkMode) {
      document.documentElement.setAttribute("dark-theme", "");
    } else {
      document.documentElement.removeAttribute("dark-theme");
    }
  }, [systemUI.isDarkMode]);


};

export default useSystemUI;
